module.exports = __webpack_public_path__ + "img/soc.e2d05ade.jpg";